import React, { Component } from 'react';
import './styles.css';

class Section extends Component{
  render(){
    let classes = ['content-section'];
    return (
      <section className={classes.join(' ') + ' ' + this.props.className || ''}> 
        {this.props.children}
      </section>
    );
  }
}

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/Section.js